<template>
  <div id="operation-record">
    <div class="ipub-filter-div mar-b-20 relative">
      <ipub-row :gutter="20">
        <ipub-col :span="8">
          <site-search-group v-model.trim="params.keyword"
                             placeholder="Search by title"
                             @search="getList()"
                             @clear="handleClear" />
        </ipub-col>
        <ipub-col :span="4">
          <div class="tr ipub-p1">
            <ipub-button v-show="user.codeList&&user.codeList.includes('SYSTEM.PUBLISH.INFO_PAGE.ADD')"
                         @click="add"
                         type="primary">Add New Info Page</ipub-button>
          </div>
        </ipub-col>
      </ipub-row>
    </div>
    <div>
      <ipub-table :columns="columns"
                  fixed
                  :pagination="pagination"
                  :dataSource="dataSource">
        <template v-slot:code="{text}">
          {{text}}
          <ipub-tooltip>
            <div slot="title">Copy to clipboard</div>
            <ipub-icon type="iconduplicate"
                       @click="copy(text)"
                       class="ipub-link mar-l-10" />
          </ipub-tooltip>
        </template>
        <template v-slot:status="{text}">
          <template v-if="text">
            <ipub-label cover
                        style="width:80px"
                        type="success"
                        size="small">Published</ipub-label>
          </template>
          <template v-else>
            <ipub-label cover
                        style="width:80px"
                        type="danger"
                        size="small">Draft</ipub-label>
          </template>
        </template>
        <template v-slot:actions="{ record }">
          <ipub-tooltip class="border-right"
                        v-show="user.codeList&&user.codeList.includes('SYSTEM.PUBLISH.INFO_PAGE.EDIT')">
            <div slot="title">Edit</div>
            <ipub-icon type="iconEdit"
                       @click="edit(record)" />
          </ipub-tooltip>
          <template v-if="user.codeList&&user.codeList.includes('SYSTEM.PUBLISH.INFO_PAGE.PUBLISH')">
            <ipub-tooltip v-if="record.released"
                          class="border-right">
              <div slot="title">Unpublish</div>
              <ipub-icon type="iconDisable"
                         @click="able(record)" />
            </ipub-tooltip>
            <ipub-tooltip v-else
                          class="border-right">
              <div slot="title">Publish</div>
              <ipub-icon type="iconAble"
                         @click="able(record)" />
            </ipub-tooltip>
          </template>
          <ipub-tooltip v-if="user.codeList&&user.codeList.includes('SYSTEM.PUBLISH.INFO_PAGE.DELETE')">
            <div slot="title">Delete</div>
            <ipub-icon type="iconDelete"
                       @click="del(record)" />
          </ipub-tooltip>
        </template>
      </ipub-table>
    </div>
    <Add :inputData="inputData"
         :isVisable="isVisable"
         @cancel="cancel"
         @confirm="confirm">
    </Add>
  </div>
</template>
<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
